import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useCustomToast } from 'design-system';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { CloseReconciliationPayload, ReconciliationSupplierDetail } from './types';

const getEndpoint = (supplierId: number) => `api/v1/cms/reconciliation/suppliers/${supplierId}/close`;

type TData = ReconciliationSupplierDetail;
type TError = AxiosError;
type TVariables = CloseReconciliationPayload;
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useCloseReconciliationApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ month, supplierId }: TVariables) => {
    try {
      const { data } = await http.post(getEndpoint(supplierId), undefined, { params: { month } });
      return data;
    } catch (error: any) {
      if (!error.response?.status) throw error;

      toast({
        description: error.response?.data?.message ?? 'Failed to close the reconciliation month',
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: ['reconciliation-close'],
  });
}
